<template>
  <div class="player-event-detail college-event-detail" :class="classObject">
    <div class="container">
      <a-row :gutter="32">
        <a-col :lg="16">
          <div class="event-detail">
            <div class="event-image">
              <img
                :src="generateImageUrl(clubEvent.image)"
                alt="Event image"
                v-if="clubEvent.image"
              />
            </div>
            <div class="event-title">
              {{ clubEvent.title }}
              <BaseButton
                v-if="clubEvent.clubId.id !== localClubId"
                type="link"
                @click="changeFav"
              >
                <BaseIcon
                  type="heart"
                  :theme="checkedFavourite.isFav ? 'filled' : 'outlined'"
                  class="favourite-icon"
                />
              </BaseButton>
            </div>
            <div class="views-count" v-if="clubEvent.clubId.id === localClubId">
              <span v-if="clubEvent.views">{{ clubEvent.views }}</span>
              <span v-else class="no-views">No</span>
              views
            </div>
            <div class="event-info-wrap">
              <a-row :gutter="32">
                <a-col :md="12">
                  <div class="basic-info location-info">
                    <div class="heading">
                      <h2 class="head-title">Event Location Info</h2>
                    </div>
                    <div class="event-info">
                      <div class="info-detail">
                        <div class="info-title">Date</div>
                        <div class="info-content">
                          {{ getDate(clubEvent.date) }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Time</div>
                        <div class="info-content">
                          {{ getTime(clubEvent.time.toUpperCase()) }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">State/City</div>
                        <div class="info-content">
                          {{
                            `${clubEvent.state && clubEvent.state.name}/${
                              clubEvent.city
                            }`
                          }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Address</div>
                        <div class="info-content half-content">
                          {{ clubEvent.location }}
                        </div>
                        <div class="info-content location">
                          <a
                            v-if="clubEvent.googleLocation"
                            :href="clubEvent.googleLocation"
                            target="_blank"
                          >
                            <a-icon type="pushpin" />View on map
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col :md="12">
                  <div class="basic-info">
                    <div class="heading">
                      <h2 class="head-title">Basic Event Info</h2>
                    </div>
                    <div class="event-info">
                      <div class="info-detail">
                        <div class="info-title">Club Name</div>
                        <div class="info-content">
                          <a
                            class="underline"
                            :href="
                              `/${$route.params.profileId}/club_profile/${clubEvent.clubId.id}/summary`
                            "
                            >{{ clubEvent.clubId.clubName }}</a
                          >
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Event Type</div>
                        <div class="info-content">
                          {{ clubEvent.eventType }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Age Group</div>
                        <div class="info-content">
                          {{ clubEvent.age && clubEvent.age.name }}
                        </div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="clubEvent.eventType === 'Game Schedule'"
                      >
                        <div class="info-title">Team A</div>
                        <div class="info-content">{{ clubEvent.teamA }}</div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="clubEvent.eventType === 'Game Schedule'"
                      >
                        <div class="info-title">Team B</div>
                        <div class="info-content">{{ clubEvent.teamB }}</div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="clubEvent.sponsor !== undefined"
                      >
                        <div class="info-title">Sponsor</div>
                        <div class="info-content">
                          {{ clubEvent.sponsor ? clubEvent.sponsor : "none" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="event-description club-event-description">
              <div class="heading">
                <h2 class="head-title">Event Description</h2>
              </div>
              <p>{{ clubEvent.description }}</p>
            </div>
            <!-- <div class="social-share extra-info tags">
              <span>Share this event :</span>
              <ul class="list">
                <li class="fb">
                  <div
                    class="fb-share-button"
                    :data-href="clubEventUrl"
                    data-layout="button"
                    data-size="small"
                  >
                    <a
                      target="_blank"
                      :href="facebookUrl"
                      class="fb-xfbml-parse-ignore"
                      ><a-icon type="facebook"
                    /></a>
                  </div>
                </li>
                <li class="twitter">
                  <a
                    target="_blank"
                    :href="twitterUrl"
                    class="twitter-share-button"
                  >
                    <a-icon type="twitter" />
                  </a>
                </li>
                <li class="linkedin">
                  <a target="_blank" :href="linkedinUrl">
                    <a-icon type="linkedin" />
                  </a>
                </li>
              </ul>
            </div> -->
          </div>
        </a-col>
        <a-col :lg="8" class="side-bar">
          <div class="other-events">
            <div class="heading">
              <h2 class="head-title">{{ sideTitle }}</h2>
            </div>
            <div class="events-list">
              <div
                class="event-card"
                v-for="(event, index) in filteredClubEvents"
                :key="index"
              >
                <div class="img-wrap">
                  <img
                    :src="generateImageUrl(event.image)"
                    alt="Event image"
                    v-if="event.image"
                  />
                </div>
                <div class="text-detail">
                  <div class="title">{{ event.title }}</div>
                  <div class="time-info">
                    <div class="date">{{ getDate(event.date) }}</div>
                    <div class="time">{{ getTime(event.time) }}</div>
                  </div>
                  <div class="view-button" @click="changeEvent(event)">
                    View Details
                    <a-icon type="double-right" />
                  </div>
                </div>
              </div>
            </div>
            <div class="button-wrap">
              <router-link
                :to="
                  $route.params.id
                    ? `/${profileId}/club_profile/${$route.params.id}/events`
                    : `/${profileId}/club_profile/events`
                "
              >
                <div class="view-all">View All Events</div>
              </router-link>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { Base } from "@/models";

const CLUB_EVENT_STORE_KEY = "clubEventStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

export default {
  name: "EventDetail",
  props: ["eventId"],
  data() {
    return {
      eventList: [],
      eventInfo: {},
      sideTitle: ""
    };
  },
  async created() {
    await this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEvent`, {
      id: this.$route.params.eventId
    });
    this.$store.dispatch(`${CLUB_EVENT_STORE_KEY}/getClubEventsV2`, {
      clubId: this.$route.params.id || this.localClubId,
      "date[gte]": new Date(),
      limit: 6,
      sort: "date",
      displayOnProfile: true
    });
    this.$store.dispatch(`${FAVOURITE_STORE_KEY}/checkFavourite`, {
      id: this.$route.params.eventId
    });
  },
  computed: {
    ...mapGetters({
      clubListEvents: `${CLUB_EVENT_STORE_KEY}/clubListEvents`,
      clubEvent: `${CLUB_EVENT_STORE_KEY}/clubEvent`,
      clubEvents: `${CLUB_EVENT_STORE_KEY}/clubEvents`,
      checkedFavourite: `${FAVOURITE_STORE_KEY}/checkedFavourite`
    }),
    profileId() {
      return Base.profileId();
    },
    classObject() {
      if (this.clubEvents.length === 0) {
        return "no-side-bar";
      } else {
        return "";
      }
    },
    filteredClubEvents() {
      return this.clubEvents
        .filter(event => event.id !== this.$route.params.eventId)
        .slice(0, 5);
    },
    localClubId() {
      return localStorage["club-id"];
    },
    clubEventUrl() {
      return `${this.baseUrl}/api/v1/events/clubevent/getHtml/${this.$route.params.eventId}`;
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?${new URLSearchParams({
        u: this.clubEventUrl
      }).toString()}`;
    },
    twitterUrl() {
      return `https://twitter.com/intent/tweet?${new URLSearchParams({
        url: this.clubEventUrl
      }).toString()}`;
    },
    linkedinUrl() {
      return `https://linkedin.com/sharing/share-offsite/?${new URLSearchParams(
        {
          url: this.clubEventUrl
        }
      )}`;
    }
  },
  methods: {
    getDate(date) {
      let d = new Date(date);
      return `${moment()
        .month(d.getUTCMonth())
        .format("MMM")} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
    },
    getTime(time) {
      if (time) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let hours = hour % 12 || 12;
        return `${hours}:${min}`;
      }
      return "";
    },
    changeEvent(event) {
      this.$router.push(
        `/${this.profileId}/club/${event.clubId._id}/event/${event.id}`
      );
    },
    async changeFav() {
      if (this.checkedFavourite.isFav) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Base.profileId(),
          favTo: this.$route.params.eventId
        });
        this.$store.dispatch(`${FAVOURITE_STORE_KEY}/unsetCheckedFavourite`);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Base.profileId(),
        favTo: this.$route.params.eventId,
        typeFav: "clubEvent"
      });
      this.$store.dispatch(`${FAVOURITE_STORE_KEY}/setCheckedFavourite`);
    }
  }
};
</script>

<style lang="sass">
.favourite-icon
  color: #d73228 !important
  font-size: 18px
.social-share
  padding: 30px 30px 0
  border: none
  display: flex
  span
    font-size: 14px
    font-weight: 500
    text-transform: uppercase
    color: #000
    padding-right: 20px
  .list
    margin: 0
    padding: 0
    list-style: none
    display: flex
    flex-wrap: wrap
    li
      margin-right: 20px
      i
        font-size: 20px
        background: #ffffff
        height: 23px
      &.fb
        i
          color: #3b5998
      &.twitter
        i
          color: #00acee
      &.linkedin
        i
          color: #0e76a8
      &.insta
        i
          color: #dd2a7b
      &:last-child
        margin-right: 0
.club-event-description
  p
    padding: 0 0 30px 0
    border-bottom: 1px solid #dddddd
</style>
